import type { ViewerTool } from './tool.js';
import { paintTool } from './paint.js';
import { pairingTool } from './pairing.js';
import { tunerTool } from './tuner.js';
import { accessoryTool } from './accessories.js';

/** 등록된 뷰어 도구. 배열 순서 = 실행 순서 (paint 가 tuner 앞 — tuner 가 paint:change 구독). */
export const TOOLS: ViewerTool[] = [
  paintTool,
  pairingTool,
  tunerTool,
  accessoryTool,
  // ← 새 도구는 여기 한 줄
];
